<a class="download-attachment-{{ displayType }}" role="button" tabindex="0" (click)="onClick()">
  <i *ngIf="displayType === 'small'" class="icon icon--docs icon--medium"></i>
  <i *ngIf="displayType === 'normal'" class="icon icon--docs icon--large"></i>
  <div class="attachment-info-wrapper">
    <p class="attachment-name" title="{{ viewModel?.name }}">
      {{ viewModel?.name }}
    </p>
    <div class="attachment-info">
      <p *ngIf="viewModel?.size > 0">{{ formatBytes(viewModel?.size) }}</p>
      <p>{{ viewModel?.date }}</p>
    </div>
  </div>
</a>
